import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { apiKeysRouts } from "../../pages/settings/APIKeys";
import { commonEntitiesResource } from "../../resources/entities/";
import { financialStatementsResource } from "../../resources/financial-statements";
import { laborForecastResource } from "../../resources/labor-forecast";
import Messages from "../../resources/messages/List/List";
import { commonOrdersResourceData, ordersResource } from "../../resources/orders/";
import { OrdersMultipleChangesPage } from "../../resources/orders/MultipleChanges2";
import { pricelistArticlesResource } from "../../resources/pricelist-articles/";
import { pricelistHolidaysResource } from "../../resources/pricelist-holidays/";
import { recurringTaskResource } from "../../resources/recurring_tasks";
import { tasksResource } from "../../resources/tasks/";
import { trucksTrafficResource } from "../../resources/trucks-traffic";
import { vehicleANPRCamerasResource } from "../../resources/vehicle-anpr-cameras";

export const osfcManagerResources = [
	<Resource name="orders" {...ordersResource} />,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource name="company-users" intent="registration" />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="tasks" {...tasksResource} />,
	<Resource name="entities" {...commonEntitiesResource} />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="trucks" intent="registration" />,
	<Resource name="trailers" intent="registration" />,
	<Resource name="drivers" intent="registration" />,
	// TODO: try to develop some StaticResource that fetch data locally or if data data doesn't change often
	<Resource name="users" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="task-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="order-history" intent="registration" />,
	<Resource name="task-history" intent="registration" />,
	<Resource name="entity-history" intent="registration" />,

	<Resource name="order-pricelist-history" intent="registration" />,
	<Resource
		name="order-pricelist"
		intent="registration"
		options={{ hasAdd: true, hasEdit: true }}
	/>,
	<Resource name="companies" intent="registration" />,
	<Resource name="terminal" intent="registration" />,
	<Resource name="external-terminal" intent="registration" />,
	<Resource name="api-keys" intent="registration" />,

	<Resource {...pricelistArticlesResource} name="pricelist-articles" />,
	<Resource {...pricelistHolidaysResource} name="pricelist-holidays" />,
	<Resource name="ports" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="pricelist-special-price" intent="registration" />,
	<Resource name="pricelist-articles-autocomplete" intent="registration" />,
	<Resource name="trucks-traffic" {...trucksTrafficResource} />,
	<Resource name="vehicle-anpr-cameras" {...vehicleANPRCamerasResource} />,
	<Resource name="labor-forecast" {...laborForecastResource} />,

	// <Resource name="recurring-tasks" {...recurringTaskResource} />,
	<Resource name="rank-priorities" intent="registration" />,
	// <Resource name="financial-statements" {...financialStatementsResource} />,
];

export const osfcManagerRoutes = [
	...apiKeysRouts,
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/orders/multiple-changes" component={OrdersMultipleChangesPage} />,
	<Route exact path="/draft-orders/multiple-changes" component={OrdersMultipleChangesPage} />,
];
